import { Box, Paper, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import Base from "../../../Base/views/Base"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import PreRegistrationPage from "./PreRegistrationPage";
import PreRegistrationBulkUpload from "./PreRegBulkUpload";
import { useDispatch } from "react-redux";
import {GetWhatsappConfigAction} from "../../../../../store/Ancillary/WhatsappConfig/Action";

const PreRegistrationLandingPage = () => {
    const [value, setValue] = useState(0);
    const dispatch = useDispatch();
       function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        dispatch(GetWhatsappConfigAction());
    }, [])
    return (
        <Base>
            <Box sx={{ minHeight: "calc(100vh - 65px)",
                        maxHeight: "calc(100vh - 65px)", overflowY: 'auto' }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    sx={{
                        minHeight: "40px", ".MuiTab-root": { minHeight: "20px", textTransform: "none" },
                        '& .MuiTabs-indicator': {
                            width: '100%',
                            display: 'flex',
                            justifyContent: "center !important",
                        },
                        mb: 1
                    }} 
                    >
                    <Tab label="Pre-registration" {...a11yProps(0)} />
                    <Tab label="Bulk Upload" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <PreRegistrationPage />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <PreRegistrationBulkUpload />
                </TabPanel>
            </Box>
        </Base>
    )
}
export default PreRegistrationLandingPage;
